import React, { useEffect } from "react";
import "./App.css";
import { useAppSelector } from "./utils/redux/hooks";
import { TopNavbar } from "./layouts/topNavBar/TopNavBar";
import MainBody from "./layouts/mainBody/MainBody";
import Footer from "./layouts/footer/Footer";
import SideImage from "./layouts/SideImage";
import MobileImage from "./layouts/MobileImage";

function App() {
  const theme = useAppSelector((state) => state.theme).value;

  // console.log(process.env.NODE_ENV);

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.add(theme);
  }, [theme]);

  return (
    <div className="  bg-lightbg-100 dark:text-amber-100 dark:bg-amber-900  text-font-900">
      <div className="flex flex-col drop-shadow-2xl min-h-screen">
        <div className="flex-grow-2 flex pt-[0.5%] pb-[0.5%] pl-[5%] pr-[5%] md:pl-[10%] md:pr-[10%] lg:pl-[15%] lg:pr-[15%] 2xl:pl-[18%] 2xl:pr-[18%] justify-between">
          <TopNavbar />
        </div>
        <div className="flex-grow bg-lightbg-200 md:flex text-amber-950  sm:pl-[0%] sm:pr-[0%]  md:pl-[5%] md:pr-[5%] lg:pl-[8%] lg:pr-[8%] xl:pl-[10%] xl:pr-[10%] 2xl:pl-[15%] 2xl:pr-[15%]  dark:text-amber-100">
          <div className="hidden  md:drop-shadow-2xl md:block md:w-[32%]">
            <SideImage />
          </div>
          <div className="  md:hidden ">
            <MobileImage />
          </div>
          <div className="pt-[2%] pb-[2%] md:w-[68%] bg-lightbg-200 ">
            <MainBody />
          </div>
        </div>
        <div className="flex-grow-0 bg-lightbg-900 pl-[5%] pr-[5%] md:pl-[10%] md:pr-[10%] lg:pl-[15%] lg:pr-[15%] 2xl:pl-[20%] 2xl:pr-[20%]  ">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default App;
